import React, { useEffect, useState } from "react";
import Loading from "../../../loading/loading.index";
import { Button, Card, Input, Select, Switch, Upload } from "antd";
import { get, post, responseValidator, SERVER } from "../../../api";
import { toast } from "react-toastify";
import "./index.scss";
import DragDrop from "../../components/dataEntry/Upload/DragDrop";

export default function CreateTicket() {
    const [loading, setLoading] = useState(false);
    const [subject, setSubject] = useState(undefined);
    const [text, setText] = useState(undefined);
    const [isActive, setIsActive] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [attachment, setAttachment] = useState(undefined);
    const [fileID, setFileID] = useState(undefined);
    const { Option } = Select;
    function submitHandler() {
        setSubmitLoading(true);
        post("/Ticket/Create", {
            subject: subject,
            text: text,
            attachment: fileID
        }).then(res => {
            setSubmitLoading(false);
            if (responseValidator(res.status)) {
                toast.success(res.data.message);
                setTimeout(
                    () => window.location.replace("/userpanel/ticket"),
                    2000
                );
            } else toast.error(res.data.message);
        });
    }

    function finishUploadHandler(e) {
        console.log(e.response);
        setAttachment(e.response.data.file);
        setFileID(e.response.data.id);
    }

    return (
        <div className="temx-ticket-create">
            {loading && <Loading />}
            <Card style={{ paddingLeft: "-38px" }} title="ایجاد تیکت">
                <div className="my-row">
                    <div className="items">
                        <label>موضوع*</label>
                        <Select placeholder='موضوع تیکت خود را انتخاب کنید' onChange={e => setSubject(e)}>
                            <Option value='احراز هویت'>احراز هویت</Option>
                            <Option value='خرید و فروش رمز ارز ها'>خرید و فروش رمز ارز ها</Option>
                            <Option value='پیشنهادات و انتقادات'>پیشنهادات و انتقادات</Option>
                            <Option value='سایر'>سایر</Option>
                        </Select>
                        {/*<Input*/}
                        {/*    value={subject}*/}
                        {/*    onChange={e => setSubject(e.target.value)}*/}
                        {/*    type="text"*/}
                        {/*    placeholder="موضوع تیکت خود را وارد کنید."*/}
                        {/*    className="item"*/}
                        {/*/>*/}
                    </div>
                </div>
                <div className="my-row">
                    <div className="items">
                        <label>متن تیکت*</label>
                        <Input.TextArea
                            onChange={e => setText(e.target.value)}
                            placeholder="متن تیکت خود را وارد کنید."
                            className="item"
                        />
                    </div>
                </div>
                <div className="my-row">
                    <div className="items">
                        <label>فایل پیوست</label>
                        {attachment ? (
                            <div className="nationalCard"></div>
                        ) : (
                            <DragDrop
                                accept="image/*, .zip, .rar"
                                finish={e => finishUploadHandler(e)}
                                name="file"
                                multiple={false}
                                url={SERVER + "/Media/Upload"}
                            />
                        )}
                    </div>
                </div>
                <div className="my-btn">
                    <Button
                        className="my-real-btn"
                        disabled={!text || !subject}
                        onClick={submitHandler}
                        type={"primary"}
                        loading={submitLoading}
                    >
                        ساخت تیکت جدید
                    </Button>
                </div>
            </Card>
        </div>
    );
}
